import React from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

function EducationList(props){
  
  function renderEditButton(education) {
    const { organization, resident } = props;
    
    return (
      <div>
        <a
          className="mr-2"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            props.editEducation(education);
          }}>
          Edit
        </a>
      </div>
    );
  }
  
  
  const { action, newEducation, editEducation, isStaffApp } = props
  const educations = props.educations.filter(occ => !occ._destroy);

  return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>School</th>
            <th>Degree</th>
            <th>Start Date</th>
            <th>Graduation Date</th>
            <th>GPA Upon Admit</th>
            <th>GPA Upon Discharge</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            educations.map((education) => {
              const {
                school_name,
                degree,
                start_date,
                graduate_date,
                move_in_gpa,
                move_out_gpa,
              } = education;

              return (
                <tr key={education.id}>
                  <td>{school_name}</td>
                  <td>{degree}</td>
                  <td>{start_date ? moment(start_date).format("MM/DD/YYYY") : null}</td>
                  <td>{start_date && !graduate_date ? 'Currently Enrolled' : moment(graduate_date).format('MM/DD/YYYY')}</td>
                  <td>{move_in_gpa}</td>
                  <td>{move_out_gpa}</td>
                  
                  <td>{props.action === "edit" && renderEditButton(education)}</td>
                </tr>
              );
            })
          }
          {
            props.action === "edit" && 
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    props.newEducation();
                  }}>
                  Add Education History
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    )
}


const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    educations: state.educations,
    organization: state.organization,
    resident: state.resident,
    groups: state.groups,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    editEducation: (education) => dispatch({ type: "EDIT_EDUCATION", payload: education }),
    newEducation: () => dispatch({ type: "NEW_EDUCATION" })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EducationList);
